import { render, staticRenderFns } from "./SettingsWarehouse.vue?vue&type=template&id=2f9b8dd2&scoped=true&"
import script from "./SettingsWarehouse.vue?vue&type=script&lang=js&"
export * from "./SettingsWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWarehouse.vue?vue&type=style&index=0&id=2f9b8dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b8dd2",
  null
  
)

export default component.exports